import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useContext, useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import PostComposer from './components/PostComposer';
import NotificationComposer from './components/NotificationComposer';
import ActivePosts from './components/ActivePosts';
import SignInForm from './components/SignInForm';
import { AuthContext } from './AuthProvider';
import ProtectedRoute from './ProtectedRoute';

function App() {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('post');
  const [showActivePosts, setShowActivePosts] = useState(false);
  const backendUrls = {dev:'https://dev-agtv.as.r.appspot.com', prod:'https://agtv-2020.el.r.appspot.com', local:'http://0.0.0.0:5000'}
  const backendUrl = backendUrls.prod;
  const handleSignOut = async () => {
    await signOut(auth);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<SignInForm />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <>
                  <nav className="navbar">
                    <div className="navbar__brand">
                      <img src="/logo.png" alt="Logo" className="navbar__logo" />
                      <div className="navbar__title">FarmTV Posts</div>
                    </div>
                    <div className="navbar__meta">
                      <span className="navbar__email">{user?.email}</span>
                      <button 
                        type="button" 
                        className={`ghost ${showActivePosts ? 'active' : ''}`}
                        onClick={() => {
                          if (showActivePosts) {
                            setShowActivePosts(false);
                            setActiveTab('post');
                          } else {
                            setShowActivePosts(true);
                          }
                        }}
                      >
                        {showActivePosts ? 'Create post' : 'Active posts'}
                      </button>
                      <button type="button" className="ghost" onClick={handleSignOut}>
                        Sign out
                      </button>
                    </div>
                  </nav>
                  {showActivePosts ? (
                    <div className="tab-shell">
                      <ActivePosts backendUrl={backendUrl} />
                    </div>
                  ) : (
                    <div className="tab-shell">
                      <div className="tab-bar">
                        <button
                          type="button"
                          className={`tab-btn ${activeTab === 'post' ? 'active' : ''}`}
                          onClick={() => setActiveTab('post')}
                        >
                          Post
                        </button>
                        <button
                          type="button"
                          className={`tab-btn ${activeTab === 'notification' ? 'active' : ''}`}
                          onClick={() => setActiveTab('notification')}
                        >
                          Notification
                        </button>
                      </div>
                      {activeTab === 'post' ? (
                        <PostComposer userEmail={user?.email} backendUrl={backendUrl} />
                      ) : (
                        <NotificationComposer userEmail={user?.email} backendUrl={backendUrl} />
                      )}
                    </div>
                  )}
                </>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
